import { StatCard } from '@skylabs-digital/backoffice-kit';
import { AlertTriangle, CheckCircle2, Percent, Webhook } from 'lucide-react';
import type { WebhooksOverview } from '../../schemas/webhook.schema';

export function WebhookKpis({ overview }: { overview: WebhooksOverview | null }) {
  const busy = overview === null;
  const o = overview;
  const window = o?.window ?? '24h';
  const rate = o?.failureRate;
  return (
    <div className="grid gap-4 sm:grid-cols-2 lg:grid-cols-4">
      <StatCard
        label={`Delivered (${window})`}
        value={o?.delivered ?? '—'}
        icon={<CheckCircle2 />}
        tone="success"
        loading={busy}
      />
      <StatCard
        label={`Failed (${window})`}
        value={o?.failed ?? '—'}
        icon={<AlertTriangle />}
        tone={o && o.failed > 0 ? 'danger' : 'neutral'}
        loading={busy}
      />
      <StatCard
        label="Failure rate"
        value={rate === null || rate === undefined ? '—' : `${(rate * 100).toFixed(1)}%`}
        hint={o && o.failureRate === null ? 'no deliveries in window' : undefined}
        icon={<Percent />}
        tone={
          rate === null || rate === undefined
            ? 'neutral'
            : rate > 0.1
              ? 'danger'
              : rate > 0
                ? 'warning'
                : 'success'
        }
        loading={busy}
      />
      <StatCard
        label="Failing endpoints"
        value={o?.failing.length ?? '—'}
        hint={o ? `of ${o.endpoints.length} declared` : undefined}
        icon={<Webhook />}
        tone={o && o.failing.length > 0 ? 'danger' : 'success'}
        loading={busy}
      />
    </div>
  );
}
